import { baseCMSApi } from '@/shared/api/base-cms-api';
import { CMS_ENDPOINTS } from '@/shared/api/endpoints';

import type { QuestionMark } from '../model/types/question-mark';

const questionMarkApi = baseCMSApi
    .enhanceEndpoints({
        addTagTypes: ['QuestionMark'],
    })
    .injectEndpoints({
        endpoints: (build) => ({
            getQuestionMarkBySlug: build.query<
                QuestionMark | null,
                { locale: string; slug: string }
            >({
                query: (params) => ({
                    url: CMS_ENDPOINTS.getQuestionMark(),
                    method: 'GET',
                    params: {
                        where: {
                            slug: {
                                equals: params.slug,
                            },
                        },
                        locale: params.locale,
                        depth: 1,
                        limit: 1,
                    },
                }),
                transformResponse: (response: unknown): QuestionMark | null => {
                    if (typeof response === 'object' && response !== null) {
                        const responseObj = response as Record<string, unknown>;

                        if (
                            Array.isArray(responseObj['docs']) &&
                            responseObj['docs'].length > 0
                        ) {
                            return {
                                id: responseObj['docs'][0].slug,
                                title: responseObj['docs'][0].title,
                                content: responseObj['docs'][0].content,
                            } as QuestionMark;
                        }

                        return null;
                    }

                    return null;
                },
                providesTags: ['QuestionMark'],
            }),
        }),
    });

export const { useGetQuestionMarkBySlugQuery } = questionMarkApi;
